import axios from "axios";
import interceptors from "@/shared/api/interceptors";

const apiClient3 = axios.create({
  baseURL: window.__CONFIG__.VUE_APP_BASE_DOMAIN + "/we",
  withCredentials: true,
});

interceptors(apiClient3);

export default apiClient3;
